import { z } from 'zod';
import { AiCareDocumentTreatmentDetailsSchema } from './AiCareDocumentTreatmentDetailsSchema';
import { baseAiGeneratedResponseSchema } from './baseAiGeneratedResponseSchema';
import { deepPartialOrNullable } from '../../../../helpers';
import {
  EndOfCareSummaryExpertSummarySchema,
  EndOfCareSummaryReturnToWorkSchema,
} from '../endOfCareSummary';
import { AiDateSchema } from './AiDateSchema';

export const EndOfCareSummaryAiGeneratedSchema = z.object({
  patient: z
    .object({
      dob: AiDateSchema,
      cancerType: z.string().nullish(),
      dateOfDiagnosis: AiDateSchema,
    })
    .nullish(),

  dateOfConsultation: AiDateSchema,

  endOfCareDate: AiDateSchema,

  treatmentDetails: deepPartialOrNullable(
    AiCareDocumentTreatmentDetailsSchema,
  ).nullish(),

  returnToWorkStatus: deepPartialOrNullable(
    EndOfCareSummaryReturnToWorkSchema,
  ).optional(),

  additionalCommunicationNotes: z.string().nullish(),

  expertSummary: deepPartialOrNullable(
    EndOfCareSummaryExpertSummarySchema,
  ).nullish(),
});

export type EndOfCareSummaryAiGenerated = z.infer<
  typeof EndOfCareSummaryAiGeneratedSchema
>;

export const EndOfCareSummaryAiGeneratedResponseSchema =
  baseAiGeneratedResponseSchema(EndOfCareSummaryAiGeneratedSchema);

export type EndOfCareSummaryAiGeneratedResponse = z.infer<
  typeof EndOfCareSummaryAiGeneratedResponseSchema
>;
